import React__default from 'react';
import { WarningCloseIcon } from '../nav/WarningCloseIcon.js';

const Warning = (props) => {
    return React__default.createElement(WarningCloseIcon, Object.assign({ fill: "#F59600" }, props));
};

export { Warning };
